@if (model?.length > 0) {
  @if (header) {
    <h3 class="mt-3">
      <strong>{{ header }}</strong>
    </h3>
  }
  <table class="table table-sm">
    <thead>
      <tr>
        @for (column of bodyColumns(model[0]); track column.label) {
          <th [colSpan]="column.colSpan || 1" [class]="column.cssClass" [ngClass]="cssClass(column)">
            {{ column.label }}
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (line of model; track line) {
        <tr>
          @for (column of bodyColumns(line); track column.label) {
            <td [colSpan]="column.colSpan || 1" [class]="column.cssClass" [ngClass]="cssClass(column)">
              <span [innerHTML]="column.value"></span>
            </td>
          }
        </tr>
        @if (bodySubTableColumnsProperty && line[bodySubTableColumnsProperty]?.length > 0) {
          <tr>
            <td class="inner-table" [colSpan]="bodyColumns(line).length">
              <app-report-table
                [model]="line[bodySubTableColumnsProperty]"
                [bodyColumns]="bodySubTableColumns"
              ></app-report-table>
            </td>
          </tr>
        }
        @if (extraSubLineBreak && line[bodySubTableColumnsProperty]?.length > 0) {
          <br />
        }
        @if (extraBoldLine) {
          <tr>
            <td [colSpan]="bodyColumns(model[0]).length" class="p-0">
              <hr />
            </td>
          </tr>
        }
      }
      @if (extraLineBreak) {
        <br />
      }
      @if (footerColumns) {
        <ng-container class="footer">
          <tr>
            @for (column of footerColumns(footerModel); track column.label) {
              <td [colSpan]="column.colSpan || 1" [class]="column.cssClass" [ngClass]="cssClass(column)">
                <strong>{{ column.label }}</strong>
                @if (column.label && column.value) {
                  <br />
                }
                <span [innerHTML]="column.value"></span>
              </td>
            }
          </tr>
          @if (footerSubTableColumnsProperty && footerModel[bodySubTableColumnsProperty]?.length > 0) {
            <tr>
              <td class="inner-table" [colSpan]="footerColumns(footerModel).length">
                <app-report-table
                  [model]="footerModel[footerSubTableColumnsProperty]"
                  [footerColumns]="footerSubTableColumns"
                ></app-report-table>
              </td>
            </tr>
          }
        </ng-container>
      }
    </tbody>
  </table>
}
